<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">


      <section id="configuration">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Real Time Enroll View</h4>
                <!-- <p class="card-text">DataTables has most features enabled by default, so all you need to do to use it
                  with
                  your own ables is to call the construction function: $().DataTable();.</p> -->
              </div>
              <div class="card-content">
                <div class="card-body card-dashboard table-responsive">
                  <table id="LogTable" class="table table-striped table-bordered zero-configuration">
                    <thead>
                      <tr>
                        <th>Device Name</th>
                        <th>Updated Time</th>
                        <th>User ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of Enroll ">

                        <td>{{item.deviceName}}</td>
                        <td>{{item.updatedTime}}</td>
                        <td>{{item.userID}}</td>

                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Device Name</th>
                        <th>Updated Time</th>
                        <th>User ID</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>




    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
